module.exports = __webpack_public_path__ + "img/resource-tech-image-50.ea8d0792.jpg";